export default __webpack_public_path__ + "static/media/A31.c722e1df.png";